import "./home-area-of-practise.styles.css";

import { Link } from "react-router-dom";

const HomeAreaOfPractiseBox = (props) => (
  <div className="col-md-6 col-12">
    <div className="home-of-area-practise-box">
      <Link to={props.link}>
        <div className="box">
          <p className="home-area-of-practise-title">{props.title}</p>
        </div>
      </Link>
    </div>
  </div>
);

export default HomeAreaOfPractiseBox;
